import { Text } from '@/components/shared/components/Text';
import { APP_ROLES } from '@/config/config';
import { AppRole } from '@/config/types';

interface GetOrderRefundRelatedActionsProps {
  openRefund: () => void;
  isOrderRefundable: boolean;
  loadingNemuruJs: boolean;
  role: AppRole;
}

export const getOrderRefundRelatedActions = ({
  openRefund,
  isOrderRefundable,
  loadingNemuruJs,
  role,
}: GetOrderRefundRelatedActionsProps) => {
  if (
    !(
      role === APP_ROLES.ADMIN ||
      role === APP_ROLES.SUPER_ADMIN ||
      role === APP_ROLES.LENDER ||
      role === APP_ROLES.MERCHANT ||
      role === APP_ROLES.CHANNEL ||
      role === APP_ROLES.AGENT ||
      role === APP_ROLES.CPC_BACK_OFFICE
    )
  )
    return [];

  return [
    {
      display: <Text tId={'REFUND'} />,
      onClick: () => openRefund(),
      iconName: 'currency_exchange',
      disabled: !isOrderRefundable,
      loading: loadingNemuruJs,
    },
  ];
};
